<footer class="cw-footer">
  <div class="cw-footer__inner">
    <div class="cw-footer__row">
      <span>© 2026 - Job Closedown</span>
      <span>Contact Closedown on 1300 483 913</span>
    </div>
    <div class="cw-footer__links">
      <a class="cw-footer__link" href="https://www.cityfm.com.au/wp-content/uploads/2026/02/IT-PO-028-Terms-and-Conditions-of-Use-Website-and-Apps-1.pdf" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
      <span aria-hidden="true">|</span>
      <a class="cw-footer__link" href="https://www.cityfm.com.au/wp-content/uploads/2023/09/HR-PO-029-City-FM-Privacy-Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    </div>
  </div>
</footer>
